import React from 'react'
import { Menu, Icon } from 'semantic-ui-react'

export default function Header({ toogleSidebar, user, sidebarVisible, isRefreshingToken, setIsRefreshingToken }) {
    return (
        <Menu className='system-menu d-print-none fixed-top'>
            <Menu.Item as="a" onClick={() => toogleSidebar(!sidebarVisible)} id="toggle-sidebar">
                <Icon style={{ fontWeight: 'bolder' }} name="bars" />
            </Menu.Item>
            {!!user && <Menu.Item as="span" style={{ cursor: 'pointer' }} className='ml-auto' onClick={() => setIsRefreshingToken(true)} >
                <Icon name='refresh' loading={isRefreshingToken}  />
                Atualizar sessão
            </Menu.Item>}
            {!!user && <Menu.Item className='user mr-0' as="span" >
                <Icon name="user" /> {user.nome}
            </Menu.Item>}
        </Menu>
    )
}
